const PublicLogo = () => {
  return (
    <div className="logoWrap">
      <a href="/">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo.png`}
          alt="Company Logo"
        />
      </a>
    </div>
  );
};
export default PublicLogo;
